//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "StatementPDF",

  data() {
    return {
      pdfMakeReady: false,
      statement: {
        statementNo: "ST-2025-001",
        date: new Date().toISOString().substr(0, 10),
        customerName: "ABC Company Limited",
        taxId: "0123456789012",
        attention: "Mr. John Smith",
        periodCovered: "January 2025",
        documentRef: "REF-2025-001",
        customerAddress:
          "Address Line 1, 123 Main Street, Building A\nAddress Line 2, Floor 5, Room 501\nAddress Line 3, Business District\nBangkok, 10500, THAILAND",
        items: [],
      },
    };
  },

  computed: {
    subtotal() {
      return this.statement.items.reduce((sum, item) => {
        return sum + item.amount;
      }, 0);
    },
    withholdingTax() {
      return this.subtotal * 0.02;
    },
    vat() {
      return (this.subtotal - this.withholdingTax) * 0.07;
    },
    grandTotal() {
      return this.subtotal - this.withholdingTax + this.vat;
    },
  },

  mounted() {
    this.waitForPdfMake();
    // สร้างข้อมูลเริ่มต้น 10 รายการ
    this.generateManyItems(10);
    this.$hideLoader();
  },

  methods: {
    waitForPdfMake() {
      const checkInterval = setInterval(() => {
        if (typeof pdfMake !== "undefined" && pdfMake.vfs && pdfMake.fonts) {
          this.pdfMakeReady = true;
          clearInterval(checkInterval);
          console.log("✅ pdfMake พร้อมใช้งาน พร้อมฟอนต์ภาษาไทย");
        }
      }, 100);

      setTimeout(() => {
        clearInterval(checkInterval);
        if (!this.pdfMakeReady) {
          console.error("❌ pdfMake โหลดไม่สำเร็จ");
          alert(
            "ไม่สามารถโหลดระบบ PDF ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต",
          );
        }
      }, 10000);
    },

    addItem() {
      this.statement.items.push({
        date: new Date().toISOString().substr(0, 10),
        description: "",
        amount: 0,
      });
    },

    removeItem(index) {
      this.statement.items.splice(index, 1);
    },

    clearItems() {
      if (confirm("ต้องการล้างข้อมูลทั้งหมดใช่หรือไม่?")) {
        this.statement.items = [];
      }
    },

    // สร้างข้อมูลตัวอย่าง
    generateManyItems(count) {
      this.statement.items = [];
      const services = [
        "Legal Consultation - General Business",
        "Document Review and Drafting",
        "Contract Preparation and Review",
        "Court Representation - Civil Case",
        "Legal Research and Analysis",
        "Due Diligence Investigation",
        "Compliance Review Services",
        "Trademark Registration Filing",
        "Corporate Secretarial Services",
        "Litigation Support Services",
        "Legal Opinion Letter",
        "Memorandum of Association Review",
        "Board Meeting Attendance",
        "Commercial Agreement Negotiation",
        "Employment Contract Drafting",
        "Intellectual Property Consultation",
        "Real Estate Transaction Review",
        "Regulatory Compliance Advice",
        "Dispute Resolution Mediation",
        "Legal Training and Seminar",
      ];

      for (let i = 0; i < count; i++) {
        const randomService =
          services[Math.floor(Math.random() * services.length)];
        const randomHours = Math.floor(Math.random() * 10) + 1;
        const randomRate = (Math.floor(Math.random() * 5) + 5) * 1000; // 5,000 - 10,000
        const amount = randomHours * randomRate;

        // สุ่มวันที่ในเดือนมกราคม 2025
        const randomDay = Math.floor(Math.random() * 31) + 1;
        const dateStr = `2025-01-${randomDay.toString().padStart(2, "0")}`;

        this.statement.items.push({
          date: dateStr,
          description: `${randomService} - ${randomHours} hours @ ${this.formatNumber(
            randomRate,
          )}/hour`,
          amount: amount,
        });
      }

      // เรียงตามวันที่
      this.statement.items.sort((a, b) => new Date(a.date) - new Date(b.date));
    },

    formatNumber(value) {
      return new Intl.NumberFormat("th-TH", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },

    numberToText(num) {
      const ones = [
        "",
        "ONE",
        "TWO",
        "THREE",
        "FOUR",
        "FIVE",
        "SIX",
        "SEVEN",
        "EIGHT",
        "NINE",
      ];
      const tens = [
        "",
        "",
        "TWENTY",
        "THIRTY",
        "FORTY",
        "FIFTY",
        "SIXTY",
        "SEVENTY",
        "EIGHTY",
        "NINETY",
      ];
      const teens = [
        "TEN",
        "ELEVEN",
        "TWELVE",
        "THIRTEEN",
        "FOURTEEN",
        "FIFTEEN",
        "SIXTEEN",
        "SEVENTEEN",
        "EIGHTEEN",
        "NINETEEN",
      ];

      if (num === 0) return "ZERO BAHT ONLY";

      const convert = (n) => {
        if (n < 10) return ones[n];
        if (n < 20) return teens[n - 10];
        if (n < 100)
          return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
        if (n < 1000)
          return (
            ones[Math.floor(n / 100)] +
            " HUNDRED" +
            (n % 100 ? " " + convert(n % 100) : "")
          );
        if (n < 1000000)
          return (
            convert(Math.floor(n / 1000)) +
            " THOUSAND" +
            (n % 1000 ? " " + convert(n % 1000) : "")
          );
        return (
          convert(Math.floor(n / 1000000)) +
          " MILLION" +
          (n % 1000000 ? " " + convert(n % 1000000) : "")
        );
      };

      const baht = Math.floor(num);
      const satang = Math.round((num - baht) * 100);

      let result = convert(baht) + " BAHT";
      if (satang > 0) {
        result += " AND " + convert(satang) + " SATANG";
      }
      return result + " ONLY";
    },

    generateMainStatement() {
      // ฟังก์ชันสำหรับสร้างหน้า Statement หลัก (อาจมีหลายหน้า)
      const mainContent = [];
      const itemsPerPage = 11; // จำนวนรายการต่อหน้าของ Main Statement

      // ===== หน้าที่ 1 =====
      mainContent.push(
        // Header บริษัท
        {
          columns: [
            {
              width: "50%",
              stack: [
                {
                  text: "DEJ-UDOM & ASSOCIATES",
                  fontSize: 16,
                  bold: true,
                  margin: [0, 0, 0, 1],
                },
                {
                  text: "ATTORNEY AT LAW",
                  fontSize: 9,
                  margin: [0, 0, 0, 2],
                },
                {
                  text: "สำนักกฎหมาย เดชอุดม แอนด์แอสโซซิเอทส์",
                  fontSize: 11,
                  margin: [0, 0, 0, 1],
                },
                {
                  text: "ทนายความ/ที่ปรึกษากฏหมาย",
                  fontSize: 9,
                },
              ],
            },
            {
              width: "50%",
              stack: [
                {
                  text: "CHARN ISSARA TOWER 2ND FLOOR, 942/69 RAMA IV ROAD,",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    "KWAENG SURIYAWONG, KHET BANGRAK, BANGKOK 10500, THAILAND",
                  fontSize: 8,
                  alignment: "right",
                },
                {
                  text:
                    "Tel : 0-2233-0055, 0-2233-0068, E-MAIL: account@dejudom.com",
                  fontSize: 8,
                  alignment: "right",
                  margin: [0, 2, 0, 0],
                },
                {
                  text: 'TAX ID. No. 0105534015348 / "HEAD OFFICE"',
                  fontSize: 8,
                  alignment: "right",
                  bold: true,
                },
              ],
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // STATEMENT
        {
          columns: [
            {
              width: "70%",
              text: "STATEMENT / ใบแจ้งหนี้",
              fontSize: 18,
              bold: true,
            },
            {
              width: "30%",
              text: `No. / เลขที่ : ${this.statement.statementNo}`,
              fontSize: 10,
              alignment: "right",
            },
          ],
          margin: [0, 0, 0, 5],
        },

        // เส้นคั่น
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
            },
          ],
          margin: [0, 0, 0, 10],
        },

        // ข้อมูลลูกค้า
        {
          columns: [
            {
              width: "55%",
              stack: [
                {
                  text: [
                    { text: "To / ถึง:  ", fontSize: 10 },
                    {
                      text: this.statement.customerName,
                      fontSize: 10,
                      bold: true,
                    },
                  ],
                  margin: [0, 0, 0, 2],
                },
                {
                  text: this.statement.customerAddress.split("\n"),
                  fontSize: 9,
                  margin: [0, 0, 0, 5],
                },
                {
                  text: `Tax ID: ${this.statement.taxId}`,
                  fontSize: 9,
                  margin: [0, 3, 0, 2],
                },
                {
                  text: `Attention : ${this.statement.attention}`,
                  fontSize: 9,
                },
              ],
            },
            {
              width: "45%",
              stack: [
                {
                  text: `Date / วันที่: ${this.formatDate(
                    this.statement.date,
                  )}`,
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 0, 0, 25],
                },
                {
                  text: `Period Covered / รอบระยะเวลา : ${this.statement.periodCovered}`,
                  fontSize: 9,
                  alignment: "right",
                  margin: [0, 0, 0, 2],
                },
                {
                  text: `Document Ref. : ${this.statement.documentRef}`,
                  fontSize: 9,
                  alignment: "right",
                },
              ],
            },
          ],
          margin: [0, 0, 0, 15],
        },

        // ตาราง หน้า 1 - 2 คอลัมน์ (Description / Amount) ไม่มี Date
        {
          table: {
            headerRows: 1,
            widths: ["*", 120],
            body: (() => {
              const firstPageTableBody = [
                [
                  { text: "Description / รายการ", fontSize: 10, bold: true },
                  {
                    text: "Amount / จำนวนเงิน",
                    fontSize: 10,
                    bold: true,
                    alignment: "right",
                  },
                ],
              ];

              // เพื่อการทดสอบ: สร้างข้อมูลจำลองในหน้าแรก
              const dummyDescriptions = [
                "Legal Consultation - General Business",
                "Contract Review and Drafting Services",
                "Corporate Compliance Advisory",
                "Trademark Registration Filing",
                "Litigation Support Services",
                "Due Diligence Investigation",
                "Board Meeting Attendance",
                "Real Estate Transaction Review",
                "Employment Contract Drafting",
                "Intellectual Property Consultation",
                "Memorandum of Association Review",
                "Regulatory Compliance Advice",
                "Commercial Agreement Negotiation",
                "Legal Research and Analysis",
                "Document Review and Drafting",
                "Dispute Resolution Mediation",
                "Legal Opinion Letter",
                "Compliance Review Services",
              ];

              // เพิ่มข้อมูลจำลอง (ตามจำนวนที่กำหนดต่อหน้า)
              const firstPageCount = Math.min(
                itemsPerPage,
                dummyDescriptions.length,
              );
              for (let i = 0; i < firstPageCount; i++) {
                firstPageTableBody.push([
                  {
                    text: dummyDescriptions[i % dummyDescriptions.length],
                    fontSize: 9,
                    margin: [5, 3, 5, 3],
                  },
                  {
                    text: this.formatNumber((i + 1) * 5000),
                    fontSize: 9,
                    alignment: "right",
                    margin: [5, 3, 5, 3],
                  },
                ]);
              }

              // เพิ่มแถว IMPORTANT
              firstPageTableBody.push([
                {
                  text:
                    "IMPORTANT: Payment must be paid in full, without deductions of foreign bank fees or taxes; we will solely be responsible for Thai tax.",
                  fontSize: 8,
                  italics: true,
                  bold: true,
                  margin: [5, 5, 5, 5],
                },
                { text: "" },
              ]);

              return firstPageTableBody;
            })(),
          },
          layout: {
            hLineWidth: function(i, node) {
              // เส้นแนวนอน: มีเฉพาะบนสุดและล่างสุด
              return i === 0 || i === node.table.body.length ? 1 : 0;
            },
            vLineWidth: function(i) {
              // เส้นแนวตั้ง: ทุกเส้น
              return 1;
            },
            paddingLeft: function() {
              return 5;
            },
            paddingRight: function() {
              return 5;
            },
            paddingTop: function() {
              return 5;
            },
            paddingBottom: function() {
              return 5;
            },
          },
          margin: [0, 0, 0, 0],
        },

        // สรุปยอดเงิน หน้า 1 - มีข้อมูลจำลอง
        {
          table: {
            widths: ["*", 120],
            body: [
              [
                {
                  text: "Sub Total / รวมเป็นเงิน",
                  fontSize: 10,
                  border: [true, true, true, false],
                },
                {
                  text: this.formatNumber(455000),
                  fontSize: 10,
                  alignment: "right",
                  border: [true, true, true, false],
                },
              ],
              [
                {
                  text: "Less Withholding Tax / ภาษีเงินได้หัก ณ ที่จ่าย",
                  fontSize: 10,
                  border: [true, false, true, false],
                },
                {
                  text: this.formatNumber(13650),
                  fontSize: 10,
                  alignment: "right",
                  border: [true, false, true, false],
                },
              ],
              [
                {
                  text: "Value Added Tax / ภาษีมูลค่าเพิ่ม",
                  fontSize: 10,
                  border: [true, false, true, false],
                },
                {
                  text: this.formatNumber(30894.5),
                  fontSize: 10,
                  alignment: "right",
                  border: [true, false, true, false],
                },
              ],
              [
                {
                  text: "Grand Total / ยอดรวม",
                  fontSize: 11,
                  bold: true,
                  fillColor: "#eeeeee",
                  border: [true, false, true, true],
                },
                {
                  text: this.formatNumber(472244.5),
                  fontSize: 11,
                  bold: true,
                  alignment: "right",
                  fillColor: "#eeeeee",
                  border: [true, false, true, true],
                },
              ],
            ],
          },
          layout: {
            paddingLeft: function() {
              return 5;
            },
            paddingRight: function() {
              return 5;
            },
            paddingTop: function() {
              return 3;
            },
            paddingBottom: function() {
              return 3;
            },
          },
          margin: [0, 0, 0, 5],
        },

        // จำนวนเงินตัวอักษร - มีข้อมูลจำลอง
        {
          text:
            "(Four Hundred Seventy Two Thousand Two Hundred Forty Four Baht and Fifty Satang Only)",
          fontSize: 10,
          bold: true,
          alignment: "center",
          margin: [0, 5, 0, 10],
        },

        // ข้อความ Please send
        {
          stack: [
            {
              text:
                "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                "โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 10],
            },
          ],
        },

        // Disclaimer
        {
          stack: [
            {
              text: "Cybersecurity & Wire Transfer Disclaimer",
              fontSize: 8,
              bold: true,
              color: "red",
              margin: [0, 0, 0, 2],
            },
            {
              text:
                "Dej-Udom & Associates shall not be liable for any loss arising from cyber fraud, phishing, or reliance on electronic communications. Payment instructions must be independently verified via a confirmed telephone number. Funds transferred to incorrect accounts due to unverified details are at the sender's risk. Please contact Dej-Udom & Associates for verification if in doubt.",
              fontSize: 7,
              color: "red",
              alignment: "justify",
            },
          ],
        },
      );

      // ===== หน้าที่ 2+ ของ Statement หลัก (ถ้ามีข้อมูลมากกว่าหน้าแรก) =====
      const dummyDescriptions = [
        "Legal Consultation - General Business",
        "Contract Review and Drafting Services",
        "Corporate Compliance Advisory",
        "Trademark Registration Filing",
        "Litigation Support Services",
        "Due Diligence Investigation",
        "Board Meeting Attendance",
        "Real Estate Transaction Review",
        "Employment Contract Drafting",
        "Intellectual Property Consultation",
        "Memorandum of Association Review",
        "Regulatory Compliance Advice",
        "Commercial Agreement Negotiation",
        "Legal Research and Analysis",
        "Document Review and Drafting",
        "Dispute Resolution Mediation",
        "Legal Opinion Letter",
        "Compliance Review Services",
      ];

      // คำนวณว่ามีข้อมูลเหลือหลังหน้าแรกหรือไม่
      const totalItems = dummyDescriptions.length;
      const remainingItems = totalItems - itemsPerPage;

      if (remainingItems > 0) {
        const additionalPages = Math.ceil(remainingItems / 15); // หน้าถัดไปแสดงได้ 15 รายการ

        for (let page = 0; page < additionalPages; page++) {
          const startIdx = itemsPerPage + page * 15;
          const endIdx = Math.min(startIdx + 15, totalItems);
          const pageItemCount = endIdx - startIdx;

          mainContent.push(
            { text: "", pageBreak: "after" },

            // หน้าที่ 2+ ของ Statement หลัก
            {
              text: "STATEMENT (Continued)",
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 15],
            },

            {
              table: {
                headerRows: 1,
                widths: ["*", 120],
                body: [
                  [
                    { text: "Description / รายการ", fontSize: 10, bold: true },
                    {
                      text: "Amount / จำนวนเงิน",
                      fontSize: 10,
                      bold: true,
                      alignment: "right",
                    },
                  ],
                  ...Array(pageItemCount)
                    .fill(null)
                    .map((_, i) => [
                      {
                        text:
                          dummyDescriptions[
                            (startIdx + i) % dummyDescriptions.length
                          ],
                        fontSize: 9,
                        margin: [5, 3, 5, 3],
                      },
                      {
                        text: this.formatNumber((startIdx + i + 1) * 5000),
                        fontSize: 9,
                        alignment: "right",
                        margin: [5, 3, 5, 3],
                      },
                    ]),
                ],
              },
              layout: {
                hLineWidth: function(i, node) {
                  // เส้นแนวนอน: มีเฉพาะบนสุดและล่างสุด
                  return i === 0 || i === node.table.body.length ? 1 : 0;
                },
                vLineWidth: function(i) {
                  // เส้นแนวตั้ง: ทุกเส้น
                  return 1;
                },
                paddingLeft: function() {
                  return 5;
                },
                paddingRight: function() {
                  return 5;
                },
                paddingTop: function() {
                  return 5;
                },
                paddingBottom: function() {
                  return 5;
                },
              },
            },
          );
        }
      }

      return mainContent;
    },

    generateDetailPages() {
      // ฟังก์ชันสำหรับสร้างหน้า Detail (มี Date / Description / Amount)
      const detailContent = [];
      const itemsPerPage = 32; // เพิ่มจาก 30 เป็น 32 รายการ

      // ถ้าไม่มีข้อมูลเลย ไม่ต้องสร้างหน้า Detail
      if (this.statement.items.length === 0) {
        return detailContent;
      }

      // คำนวณจำนวนหน้าตามข้อมูลจริง
      const totalDetailPages = Math.ceil(
        this.statement.items.length / itemsPerPage,
      );

      for (let page = 0; page < totalDetailPages; page++) {
        const startIndex = page * itemsPerPage;
        const endIndex = Math.min(
          (page + 1) * itemsPerPage,
          this.statement.items.length,
        );
        const pageItems = this.statement.items.slice(startIndex, endIndex);

        // Page break สำหรับหน้าแรกของ Detail
        detailContent.push({ text: "", pageBreak: "after" });

        // สร้างตาราง 3 คอลัมน์
        const tableBody = [
          [
            { text: "Date / วันที่", fontSize: 10, bold: true },
            { text: "Description / รายการ", fontSize: 10, bold: true },
            {
              text: "Amount / จำนวนเงิน",
              fontSize: 10,
              bold: true,
              alignment: "right",
            },
          ],
        ];

        // เพิ่มรายการ
        pageItems.forEach((item) => {
          tableBody.push([
            { text: this.formatDateShort(item.date), fontSize: 9 },
            { text: item.description, fontSize: 9 },
            {
              text: this.formatNumber(item.amount),
              fontSize: 9,
              alignment: "right",
            },
          ]);
        });

        detailContent.push({
          table: {
            headerRows: 1,
            widths: ["15%", "*", "20%"],
            body: tableBody,
            dontBreakRows: true,
          },
          layout: {
            hLineWidth: function(i, node) {
              // เส้นแนวนอน: มีเฉพาะบนสุดและล่างสุด
              return i === 0 || i === node.table.body.length ? 1 : 0;
            },
            vLineWidth: function(i) {
              // เส้นแนวตั้ง: ทุกเส้น
              return 1;
            },
            paddingLeft: function() {
              return 5;
            },
            paddingRight: function() {
              return 5;
            },
            paddingTop: function() {
              return 5;
            },
            paddingBottom: function() {
              return 5;
            },
          },
          margin: [0, 0, 0, 10],
        });

        // Footer เหมือนกันทุกหน้า
        detailContent.push({
          stack: [
            {
              text:
                "Please send us a certificate of above withholding income tax issued to our firm together with your payment",
              fontSize: 8,
              alignment: "center",
              margin: [0, 0, 0, 1],
            },
            {
              text:
                "โปรดส่งหนังสือรับรองการหักภาษี ณ ที่จ่ายมาพร้อมกับเอกสารชำระเงิน",
              fontSize: 8,
              alignment: "center",
            },
          ],
        });
      }

      return detailContent;
    },

    generateDocDefinition() {
      // รวม Statement หลัก + Detail เข้าด้วยกัน
      const mainStatement = this.generateMainStatement();
      const detailPages = this.generateDetailPages();

      const allContent = [...mainStatement, ...detailPages];

      const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 40, 40, 40],
        content: allContent,
        defaultStyle: {
          font: "Sarabun",
          fontSize: 10,
        },
      };

      return docDefinition;
    },

    formatDateShort(dateString) {
      const date = new Date(dateString);
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const months = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ];
      return `${date.getDate()} ${
        months[date.getMonth()]
      } ${date.getFullYear() + 543}`;
    },

    previewPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        pdfMake.createPdf(docDefinition).open();
        console.log("✅ เปิดตัวอย่าง PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการสร้าง PDF: " + error.message);
      }
    },

    downloadPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        const fileName = `Statement_${this.statement.statementNo}_${this.statement.date}.pdf`;
        pdfMake.createPdf(docDefinition).download(fileName);
        console.log("✅ ดาวน์โหลด PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการดาวน์โหลด PDF: " + error.message);
      }
    },

    printPDF() {
      if (!this.pdfMakeReady) {
        alert("กรุณารอสักครู่ ระบบกำลังโหลด...");
        return;
      }

      try {
        const docDefinition = this.generateDocDefinition();
        pdfMake.createPdf(docDefinition).print();
        console.log("✅ สั่งพิมพ์ PDF สำเร็จ");
      } catch (error) {
        console.error("❌ เกิดข้อผิดพลาด:", error);
        alert("เกิดข้อผิดพลาดในการพิมพ์ PDF: " + error.message);
      }
    },
  },
};
